<template>
  <el-form label-position="top" :model="account" :rules="rules" ref="accountForm">
    <el-form-item
      label="Bank"
      prop="bank"
    >
      <el-input
        v-model="account.bank"
      />
    </el-form-item>
    <el-form-item
      label="Számlaszám"
      prop="value"
    >
      <el-input
        v-model="account.value"
      />
    </el-form-item>
    <el-switch
      v-model="account.is_primary"
      active-text="Elsődleges számlaszám"
    />
  </el-form>
</template>

<script>
  export default {
    props: ['defaultAccount', 'formType'],
    data() {
      return {
        account: {},
        rules: {
          value: [
            { required: true, message: 'Számlaszám megadása kötelező', trigger: 'blur'}
          ]
        }
      };
    },
    watch: {
      defaultAccount: {
        handler(newVal) {
          this.account = Object.assign({}, newVal);
        },
        deep: true,
      },
    },
    async mounted() {
      this.account = Object.assign({}, this.defaultAccount);
    },
  };
</script>
